import { FileAttachment } from 'components/common/AttachmentPreview';
import {
  supportMedia,
  MediaItem as MediaItemType,
  AddMediaObject
} from 'data/addmedia';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
  createContext,
  PropsWithChildren,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
  useCallback
} from 'react';

interface MediaWidgetProps {
  isOpenMedia: boolean;
  addMediaObject: AddMediaObject;
  setAddMediaObject: Dispatch<SetStateAction<AddMediaObject>>;
  setIsOpenMedia: Dispatch<SetStateAction<boolean>>;
  sentMediaItem: ({
    message,
    attachments
  }: {
    message?: string;
    attachments?: { images?: string[]; file?: FileAttachment };
  }) => void;
}

export const MediaWidgetContext = createContext({} as MediaWidgetProps);

const MediaWidgetProvider = ({ children }: PropsWithChildren) => {
  dayjs.extend(relativeTime);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [addMediaObject, setAddMediaObject] = useState(supportMedia);

  const sentMediaItem = useCallback(
    ({
      message,
      attachments
    }: {
      message?: string;
      attachments?: { images?: string[]; file?: FileAttachment };
    }) => {
      const newMediaItems = [
        ...addMediaObject.mediaItems,
        {
          id: Date.now(),
          type: 'added',
          time: dayjs().toNow(),
          readAt: null,
          message,
          attachments
        } as MediaItemType
      ];
      const newAddMediaObject = { ...addMediaObject, messages: newMediaItems };
      setAddMediaObject(newAddMediaObject);
    },
    [addMediaObject]
  );

  return (
    <MediaWidgetContext.Provider
      value={{
        addMediaObject,
        setAddMediaObject,
        isOpenMedia,
        setIsOpenMedia,
        sentMediaItem
      }}
    >
      {children}
    </MediaWidgetContext.Provider>
  );
};

export const useMediaWidgetContext = () => useContext(MediaWidgetContext);

export default MediaWidgetProvider;
